import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { selectors, CurrentBusiness } from "../../../reducers/lab";
import { useUser, useIsAuthed } from "../../../auth";

import CopyButton from "../CopyButton";
import "./UserProfile.styles.scss";

interface UserProfileComponentInterface {
	currentBusiness?: CurrentBusiness;
}

export interface UserProfileInterface {
	name: string;
	picture: string;
	email: string;
	default_business_id: string;
}

const UserProfile = (props: UserProfileComponentInterface) => {
	const [userProfile, setUserProfile] = useState<UserProfileInterface>();
	const [isOpen, setIsOpen] = useState(false);
	const isAuth = useIsAuthed();
	const user = useUser();
	const ref = useRef(null);
	const { currentBusiness } = props;

	useEffect(() => {
		if (!isAuth) return;
		if (user) {
			setUserProfile(user.profile);
		}

		function handleClickOutside(event) {
			if (ref.current && !ref.current.contains(event.target)) {
				setIsOpen(!isOpen);
			}
		}
		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}
	}, [isAuth, user, ref, isOpen]);

	return (
		<>
			{userProfile ? (
				<div className="user-profile" ref={ref}>
					<img
						className="user-image"
						src={userProfile.picture}
						onClick={() => setIsOpen(!isOpen)}
					></img>
					<div className="user-profile-dropdown" style={{ display: isOpen ? "flex" : "none" }}>
						<p className="user-email" title={userProfile.email}>
							{userProfile.email}
						</p>
						<div className="user-profile-utils">
							<p>
								Business ID:{" "}
								{currentBusiness ? currentBusiness.businessId : userProfile.default_business_id}
								<CopyButton
									businessId={
										currentBusiness
											? currentBusiness.businessId
											: userProfile.default_business_id
									}
								/>
							</p>
							{/* <a href="#">Billing</a>
						<a href="#">API Keys<i className="fal fa-external-link-square"></i></a>
						<a href="#">Connections</a>
						<a href="#">Customer Lists</a>
						<a href="#">Settings</a> */}
						</div>
						<a className="logout-button" href="/app/logout">
							Logout
						</a>
						<span>2.5.8</span>
					</div>
				</div>
			) : null}
		</>
	);
};

const mapStateToProps = (state) => ({
	currentBusiness: selectors.selectCurrentBusiness(state),
});

export default connect(mapStateToProps)(UserProfile);
